import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Store } from '@ngrx/store'
import { AppState } from "../../reducers";
import { CheckoutActions } from "./checkout.actions";
import { ShoppingCart } from "../../models";

@Injectable()
export class CheckoutResolver implements Resolve<void> {

	constructor(
		private store: Store<AppState>,
		private checkoutActions: CheckoutActions
	) {}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
		this.store
		.select<ShoppingCart>(s => s.shoppingCart.shoppingCart)
		.filter((shoppingCart) => !!shoppingCart)
		.take(1)
		.subscribe((shoppingCart) => {
			this.store.dispatch(this.checkoutActions.loadAvailableShipmentTypes(shoppingCart.secureId));
		})
	}
}



// WEBPACK FOOTER //
// ./src/app/components/checkout-components/checkout.resolver.ts